import { CustomerProfileResponse } from '@porterin/booking-flow/src/auth/domain/api-models/CustomerProfileApiModel';
import { API_ENDPOINTS } from '@porterin/booking-flow/src/auth/domain/config/api';
import { CustomerProfile } from '@porterin/booking-flow/src/auth/domain/entities/CustomerProfile';
import { toCustomerProfileEntity } from '@porterin/booking-flow/src/auth/domain/entity-mappers/CustomerProfileEntityMapper';
import {
  createAuthenticatedHeaders,
  createNetworkError,
} from '@porterin/booking-flow/src/auth/domain/helpers/authHelpers';
import { fireApiErrorSentry } from '@porterin/component-library/src/ts-utils/analytics/sentry/SentryHelpers';
import axios, { AxiosError } from 'axios';

export const customerProfile = async (
  webTrackingId: string,
  authToken: string,
  mobile: string,
): Promise<CustomerProfile> => {
  try {
    const headers = createAuthenticatedHeaders(
      webTrackingId,
      authToken,
      mobile,
    );

    const response = await axios.get<CustomerProfileResponse>(
      `${API_ENDPOINTS.CUSTOMER_PROFILE}`,
      { headers },
    );

    return toCustomerProfileEntity(response.data);
  } catch (error) {
    fireApiErrorSentry(error, 'customerProfile');
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      throw createNetworkError(
        axiosError.response?.status ?? 500,
        axiosError.message,
      );
    }
    throw error;
  }
};
